import { render, staticRenderFns } from "./ProjectSelectorButton.vue?vue&type=template&id=6f070887&scoped=true"
import script from "./ProjectSelectorButton.vue?vue&type=script&lang=js"
export * from "./ProjectSelectorButton.vue?vue&type=script&lang=js"
import style0 from "./ProjectSelectorButton.vue?vue&type=style&index=0&id=6f070887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f070887",
  null
  
)

export default component.exports